'use strict';

global.expect = require('expect.js');

global.sinon = require('sinon');

